export default {
  id: "page16",
  header: "Testowanie produktów w warunkach domowych",
  show: "parseInt(values.ankieta_zgodaTestyDom)>0",
  questions: [
    {
      type: "justlabel",
      label:
        "Jakie produkty mógłby / mogłaby Pan(i) testować w warunkach domowych?",
      info:
        "Dla każdego produktu proszę zaznaczyć jedną odpowiedź TAK lub NIE.",
      number: "26a"
    },
    {
      type: "choice_names",
      options: ["TAK", "NIE"],
      topLine: true,
      labelWidth: "is-three-fifths",
      bottomLine: true
    },
    {
      label: "Desery (budynie, kisiele, galaretki, inne rodzaje deserów)",
      type: "radio",
      id: "kategoria10_desery",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label:
        "Desery i dania instant – do zalewania wrzątkiem (budynie, kisiele, owsianki)",
      type: "radio",
      id: "kategoria10_deseryInstant",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label:
        "Dodatki do ciast podstawowe (proszek do pieczenia, cukry smakowe, aromaty, drożdże, mąka, żelatyna, soda itp.)",
      type: "radio",
      id: "kategoria10_dodatkiPodst",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Dodatki do ciast zaawansowane (kremy, masy, polewy, dekoracje)",
      type: "radio",
      id: "kategoria10_dodatkiZaaw",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: 'Dodatki ułatwiające pieczenie lub gotowanie typu "fix"',
      type: "radio",
      id: "kategoria10_dodatkiUlatw",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Gotowe mieszanki do ciast (ciasta z torebki / kartonika)",
      type: "radio",
      id: "kategoria10_mieszankiCiasta",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Gotowe mieszanki do pikantnych wypieków (pizza, tarty, bułeczki)",
      type: "radio",
      id: "kategoria10_mieszankiSlone",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Pizze mrożone",
      type: "radio",
      id: "kategoria10_pizzaTest",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Inne produkty mrożone, np. zapiekanki",
      type: "radio",
      id: "kategoria10_mrozone",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Gotowe ciasta z lodówki, np. ciasto francuskie, na pizzę itp.",
      type: "radio",
      id: "kategoria10_ciastaLodowkaTest",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label:
        "Produkty nabiałowe z lodówki do pieczenia, gotowania (twarogi, śmietany, margaryna lub inne tłuszcze itp.)",
      type: "radio",
      id: "kategoria10_nabialPieczenie",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Gotowe desery z lodówki",
      type: "radio",
      id: "kategoria10_deseryLodowka",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    },
    {
      label: "Inne produkty spożywcze",
      type: "radio",
      id: "kategoria10_spozywcze",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      labelStrong: false,
      options: [{ value: "1" }, { value: "0" }]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/page16.js